import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import { pathForLang } from '../i18n/paths';

function LanguageSwitch({ className = '', onNavigate }) {
  const { pathname, hash } = useLocation();
  const { lang } = useI18n();
  const deTarget = pathForLang(pathname, hash, 'de');
  const enTarget = pathForLang(pathname, hash, 'en');

  return (
    <span className={`michaela-lang-switch ${className}`.trim()}>
      <Link
        to={deTarget}
        hrefLang="de"
        lang="de"
        className={lang === 'de' ? 'is-current' : undefined}
        aria-current={lang === 'de' ? 'page' : undefined}
        onClick={onNavigate}
      >
        DE
      </Link>
      <span aria-hidden="true">|</span>
      <Link
        to={enTarget}
        hrefLang="en"
        lang="en"
        className={lang === 'en' ? 'is-current' : undefined}
        aria-current={lang === 'en' ? 'page' : undefined}
        onClick={onNavigate}
      >
        EN
      </Link>
    </span>
  );
}

export default LanguageSwitch;
